@if (!breadcrumbStoreService.isHidden()) {
  <nav hlmBreadcrumb>
    <ol hlmBreadcrumbList>
      <li hlmBreadcrumbItem>
        <ocp-breadcrumb-home-item
          [hideArrowRight]="!breadcrumbStoreService.breadcrumbItems().length"
        />
      </li>

      @for (
        item of breadcrumbStoreService.breadcrumbItems();
        track item.routerLink;
        let isLast = $last
      ) {
        <li
          hlmBreadcrumbItem
          class="min-w-0"
          [class.breadcrumb__item--last]="item.data?.isLastItem"
        >
          @if (breadcrumbStoreService.dropdownMenuItems().length && item.data?.isLastItem) {
            @if (item.data; as data) {
              <ocp-breadcrumb-dropdown-item
                [label]="item.label ?? ''"
                [footerActions]="data.footerDropdownActions ?? []"
              />
            }
          } @else {
            <ocp-breadcrumb-item
              [truncate]="item.data?.truncate"
              [iconSrc]="item.data?.icon ?? ''"
              [label]="item.label ?? ''"
              queryParamsHandling="preserve"
              [routerLink]="normalizeRouterLink(item.routerLink)"
            />
          }
        </li>

        @if (!isLast) {
          <li hlmBreadcrumbSeparator aria-hidden="true">
            <ocp-themed-icon name="chevron-right.svg" size="9"></ocp-themed-icon>
          </li>
        }
      }
    </ol>
  </nav>
}
